import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.scss';
import "../node_modules/bootstrap/dist/js/bootstrap";
//import { BrowserRouter } from "react-router-dom";
import { HashRouter } from 'react-router-dom';
import { TheProvider } from './TheProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <TheProvider>
      <App />
    </TheProvider>
  </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
